import { render, staticRenderFns } from "./_activities-tabs.vue?vue&type=template&id=2af16134&scoped=true&"
import script from "./_activities-tabs.vue?vue&type=script&lang=ts&"
export * from "./_activities-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af16134",
  null
  
)

export default component.exports